import { z } from 'zod';

export enum ChargeFailureReason {
    ACCOUNT_CLOSED = 'account_closed',
    ACCOUNT_FROZEN = 'account_frozen',
    ACCOUNT_DECLINED = 'account_declined',
    ACCOUNT_DETAILS_INVALID = 'account_details_invalid',
    AUTHENTICATION_FAILED = 'authentication_failed',
    AUTHENTICATION_REQUIRED = 'authentication_required',
    AUTHORIZATION_FAILED = 'authentication_failed',
    CARD_EXPIRED = 'card_expired',
    CARD_DECLINED = 'card_declined',
    CARD_RESTRICTED = 'card_restricted',
    CARD_CVC_INCORRECT = 'card_cvc_incorrect',
    BANK_NOT_SUPPORTED = 'bank_not_supported',
    CURRENCY_NOT_SUPPORTED = 'currency_not_supported',
    INSUFFICIENT_FUNDS = 'insufficient_funds',
    INTERNAL_BANK_ERROR = 'internal_bank_error',
    PROCESSING_ERROR = 'processing_error',
    REFERENCE_INVALID = 'reference_invalid',
    PAYMENT_LIMIT_EXCEEDED = 'payment_limit_exceeded',
    UNKNOWN_REFUSAL_REASON = 'unknown_refusal_reason',
}

function uniqueEnumValues<T extends Record<string, string>>(enumObj: T): [string, ...string[]] {
    const values = Array.from(new Set(Object.values(enumObj))) as string[];

    return values as [string, ...string[]]; // Ensure non-empty array
}

// Create Zod schema for the unique enum values
export const ChargeFailureReasonSchema = z.enum(uniqueEnumValues(ChargeFailureReason)).openapi({
    description: 'Reasons for charge failure',
    example: ChargeFailureReason.ACCOUNT_CLOSED,
});
